import type { NavigationPageDisplayState } from "../../../types/blocks/navigation/NavigationPageOption";

export function parseNavigationDisplayStatesJson(
  value: string,
): NavigationPageDisplayState[] {
  const parsed: unknown = JSON.parse(value);
  if (!Array.isArray(parsed) || parsed.length === 0) {
    throw new Error("Display states must be a non-empty JSON array.");
  }

  const ids = new Set<string>();
  for (const entry of parsed) {
    if (!entry || typeof entry !== "object" || Array.isArray(entry)) {
      throw new Error("Each display state must be a JSON object.");
    }

    const state = entry as Record<string, unknown>;
    if (typeof state.id !== "string" || !state.id.trim()) {
      throw new Error("Each display state must have a non-empty string ID.");
    }
    if (typeof state.name !== "string" || !state.name.trim()) {
      throw new Error("Each display state must have a non-empty string name.");
    }
    if (ids.has(state.id)) {
      throw new Error(`Display state IDs must be unique: ${state.id}`);
    }
    ids.add(state.id);
  }

  return parsed as NavigationPageDisplayState[];
}
